<script setup lang="ts">
defineProps<{
  label: string
  pill?: string
}>()
</script>

<template>
  <div
    class="group flex items-center space-x-1 rounded-full bg-main-100 py-[3px] pl-[3px] pr-1.5 text-sm font-medium text-main-900 transition bordershadow-main-light hover:bordershadow-main"
  >
    <div v-if="pill" class="h-full rounded-full bg-main-900 px-2 text-main-50">{{ pill }}</div>
    <span> {{ label }} </span>

    <div class="relative flex h-3 w-6 items-center justify-center overflow-hidden">
      <Icon
        name="lucide:move-right"
        size="18"
        class="hover absolute transition duration-300 group-hover:translate-x-8"
      />
      <Icon
        name="lucide:move-right"
        size="18"
        class="hover absolute -translate-x-8 transition duration-300 group-hover:translate-x-0"
      />
    </div>
  </div>
</template>
